<template>
  <div>
    <base-header class="pb-1">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h1 class="text-primary">BIENVENIDO A LA PLATAFORMA</h1>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt-4">
      <div class="row">
        <img class="d-block mx-auto" src="/img/logoSivo.png" height="410" width="auto" />
      </div>
      <br><br><br>
    </div>
    <div v-if="agencias.length">
    <div v-if="user.relationships.agencias.data.length > 1">
      <modal data-backdrop="static" data-keyboard="false" :show.sync="showUpdateModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Seleccionar Agencia</h6>
        <form class="new-event--form" @submit.prevent="updateAgency">
          <base-input label="Indique la agencia desde donde está trabajando">
            <multiselect v-model="user.attributes.agencia_activa" :options="agencias" placeholder="Selecccione una agencia" label="nombre" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <span v-if="validation != null">
            <small class="argon-error" v-text="validation"/>
          </span>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateAgency">Confirmar</button>
        </template>
      </modal>
      </div>
    </div>
    <modal data-backdrop="static" data-keyboard="false" :show.sync="showUpdatePasswordModal" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Actualizar Contraseña</h6>
      <form class="new-event--form" @submit.prevent="updatePassword">
        <base-input label="Contraseña"
                    placeholder="Contraseña"
                    v-model="password"
                    input-classes="form-control-alternative new-event--title"
                    type="password">
        </base-input>
        <validation-error :errors="apiValidationErrors.password" />
        <base-input label="Confirmar Contraseña"
                    placeholder="Confirmar Contraseña"
                    v-model="password_confirmation"
                    input-classes="form-control-alternative new-event--title"
                    type="password">
        </base-input>
        <validation-error :errors="apiValidationErrors.password_confirmation" />
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      </form>
      <template slot="footer">
        <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updatePassword">Confirmar</button>
      </template>
    </modal>
  </div>
</template>
<script>
  import { Modal } from "@/components/";
  import Multiselect from 'vue-multiselect';
  import formMixin from "@/mixins/form-mixin";
  import ValidationError from "@/components/ValidationError.vue";
  export default {
    components: {
      Modal,
      Multiselect,
      ValidationError
    },
    mixins: [formMixin],
    data() {
      return {
        user: {},
        agencias: [],
        agencias_total: [],
        showUpdateModal: false,
        lastPath: null,
        nextPath: null,
        validation: null,
        showUpdatePasswordModal: false,
        password: null,
        password_confirmation: null,
        password_update: {}
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.lastPath = from
        vm.nextPath = to
        vm.openModal();
      })
    },
    created() {
      
    },
    methods: {
      openModal(){
        if(this.lastPath.name == 'Login' && this.nextPath.name == 'Dashboard'){
          this.getProfile();
          this.showUpdateModal = true;
        }
      },
      async getProfile() {
        await this.$store.dispatch("profile/me");
        this.user = await { ...this.$store.getters["profile/me"] };
        this.user.attributes.agencia_activa = null;

        await this.$store.dispatch("profile/updateAgencyToNull", this.user);

        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
          },
          page: {
            number: 1,
            size: 10000,
          },
        };
        await this.$store.dispatch("agencias/list", params).then(() => {
          this.agencias_total = this.$store.getters["agencias/list"];
        });
        const agencias = [];
        this.user.relationships.agencias.data.forEach(item => {
          const agencia = item.attributes.nombre;
          if(agencias.includes(agencia) == false){
            agencias.push(agencia);
          }
        });
        this.agencias = this.agencias_total.filter(item => agencias.includes(item.nombre));
        if(this.agencias.length == 1){
          this.user.attributes.agencia_activa = this.user.relationships.agencias.data[0].attributes;
          this.updateAgency();
        }
        if(this.agencias.length == 0){
          this.user.attributes.agencia_activa = 'sin agencia';
          this.updateAgency();
        }
      },

      async updateAgency() {
        if(this.user.attributes.agencia_activa == null){
          this.validation = 'Es necesario seleccionar una agencia.'
        }else{
          try {
          await this.$store.dispatch("profile/updateAgency", this.user);
          if(this.user.attributes.agencia_activa == 'sin agencia'){
            this.$notify({
              type: "success",
              message: "Usuario sin agencia(s) asignada.",
              duration: -1
            });
          }else{
            this.$notify({
              type: "success",
              message: "Agencia asignada satisfactoriamente.",
              duration: -1
            });
          }
          
          //await this.$store.dispatch("profile/me");
          //await this.$store.getters["profile/me"];
          } catch (error) {
            if (error.response.data.errors[0]) {
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
            } else {
                this.$notify({
                    type: "danger",
                    message: "Oops, ha ocurrido un problema!",
                    duration: -1
                });
            }
          }
          this.showUpdateModal = false;
          if(this.user.attributes.password_actualizado === 0){
            this.showUpdatePasswordModal = true;
          }
        }
      },

      async updatePassword(){
        await this.$store.dispatch("profile/me");
        this.user = await { ...this.$store.getters["profile/me"] };
        this.user.attributes.password = this.password;
        this.user.attributes.password_confirmation = this.password_confirmation;
        try {
          await this.$store.dispatch("profile/updatePassword", this.user);
          this.resetApiValidation();

          this.$notify({
            type: "success",
            message: "Contraseña actualizada satisfactoriamente.",
            duration: -1
          });
          this.showUpdatePasswordModal = false;
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      }
    },
  };
</script>
<style lang="scss">
    .argon-error {
      position: relative;
      bottom: 25px;
      color: #fb6340;
      }
  
</style>